import { buildProGPTUrl } from '../../../../features/utils/buildProGPTUrl';
import { PaginatedUsers, User } from '../../../../domain/users/models/User';
import { BaseService } from '../../../http/BaseHttpService';
import { CreateUserCommand, EditUserCommand, UpdateUserPinnedAgentsCommand } from '../dtos/requests/ProGPTUserRequest';
import { ProGPTResultDto } from '../dtos/responses/ProGPTResultDto';
import { ProGPTPaginatedUsersDto, ProGPTUserDto } from '../dtos/responses/ProGPTUserResponseDto';
import { IProGptUserService } from '../interfaces/IProGPTUserService';
import { mapProGPTPaginatedUsersDtoToModel, mapProGPTUserDtoToModel } from '../mappers/ProGPTUserMapper';


export class ProGPTUserService extends BaseService implements IProGptUserService {
    private readonly baseUrl: string;

    constructor(baseUrl: string) {
        super();
        this.baseUrl = baseUrl;
    }

    public async createUserAsync(command: CreateUserCommand, accessToken: string): Promise<ProGPTResultDto<User>> {
        const response = await this.getResponseAsync<ProGPTResultDto<ProGPTUserDto>>(
            {
                url: buildProGPTUrl(this.baseUrl, '/User/create'),
                method: 'POST',
                body: command,
            },
            accessToken,
        );

        return {
            ...response,
            value: mapProGPTUserDtoToModel(response.value),
        };
    }

    public async getAllUsersAsync(
        accessToken: string,
        pageNumber: number = 1,
        pageSize: number = 10,
        searchTerm: string = '',
    ): Promise<ProGPTResultDto<PaginatedUsers>> {
        const response = await this.getResponseAsync<ProGPTResultDto<ProGPTPaginatedUsersDto>>(
            {
                url: buildProGPTUrl(
                    this.baseUrl,
                    `/User/getAllUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&searchTerm=${encodeURIComponent(searchTerm)}`,
                ),
                method: 'GET',
            },
            accessToken,
        );

        return {
            ...response,
            value: mapProGPTPaginatedUsersDtoToModel(response.value),
        };
    }

    public async updateUserAsync(
        userId: string,
        command: EditUserCommand,
        accessToken: string,
    ): Promise<ProGPTResultDto<User>> {
        const response = await this.getResponseAsync<ProGPTResultDto<ProGPTUserDto>>(
            {
                url: buildProGPTUrl(this.baseUrl, `/User/${userId}`),
                method: 'PATCH',
                body: command,
            },
            accessToken,
        );

        return {
            ...response,
            value: mapProGPTUserDtoToModel(response.value),
        };
    }

    public async getUserByIdAsync(userId: string, accessToken: string): Promise<ProGPTResultDto<User>> {
        const response = await this.getResponseAsync<ProGPTResultDto<ProGPTUserDto>>(
            {
                url: buildProGPTUrl(this.baseUrl, `/User/${userId}`),
                method: 'GET',
            },
            accessToken,
        );

        return {
            ...response,
            value: mapProGPTUserDtoToModel(response.value),
        };
    }

    public async updatePinnedAgentsAsync(
        userId: string,
        command: UpdateUserPinnedAgentsCommand,
        accessToken: string,
    ): Promise<ProGPTResultDto<User>> {
        const response = await this.getResponseAsync<ProGPTResultDto<ProGPTUserDto>>(
            {
                url: buildProGPTUrl(this.baseUrl, `/User/updatePinned/${userId}`),
                method: 'POST',
                body: command,
            },
            accessToken,
        );

        return {
            ...response,
            value: mapProGPTUserDtoToModel(response.value),
        };
    }
}
